import React, { useState } from "react";
import DownloadReportModal from "../downloadReport/Modal";

function RollingHeader() {
  const [showGenerateReport, setShowGenerateReport] = useState(false)
  return (
    <>
    <div className="download-report-rolling">
        <div className="">
      <h2>Rolling Reserve Table</h2>
</div>
      <div className="download-report-rolling">
      <button
  className="btn-report-rolling"
  onClick={() => setShowGenerateReport(true)}
>
  Download Report
</button>
      </div>

 </div>
 {showGenerateReport && (
  <DownloadReportModal onClose={() => setShowGenerateReport(false)} />
)}
 </>
  );
}

export default RollingHeader;
